import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Tilstand',
      fields: {
        delivery_visible: {
          label: 'Levering synlig',
        },
        has_delivery: {
          label: 'Levering',
        },
        delivery_enabled: {
          label: 'Levering aktiv',
        },
      },
    },
    delivery_mode: {
      title: 'Leveringsmåde',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Restaurantens egne chauffører',
            [DeliveryMode.External]: 'Eksterne chauffører ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Note til chaufførens afhentning',
          placeholder: 'Ekstra nyttige oplysninger til chaufføren om afhentning (fx hvordan man finder indgangen osv.)',
        },
        instant_print_enabled: {
          label: 'Udskriv bon uden at vente på chauffør',
        },
        provider_not_connected: {
          wolt_drive: 'Endnu ikke forbundet: denne restaurant har ikke et gyldigt Wolt venue-id.',
          connects_on_external: '{{provider}} forbindes, når leveringstilstand er sat til eksterne chauffører og gemt.',
          not_connected_yet:
            '{{provider}} er endnu ikke forbundet for denne restaurant. Hvis dette ikke ændrer sig, kontakt venligst support.',
        },
      },
    },
    scheduled_orders: {
      title: 'Forudbestillinger',
      fields: {
        has_scheduled_orders: {
          label: 'Tillader du, at dine kunder bestiller på forhånd til bestemte tidspunkter?',
        },
        min_schedule_ahead_time_delivery: {
          label: 'Minimumstid (minutter) i forvejen for planlægning af <strong>leveringsordrer</strong>',
          placeholder: '60',
          validation_name: 'Minimumstid for planlægning af levering',
          external_hint: 'Ved ekstern levering skal dette være mindst {{minutes}} minutter (2 timer). ',
        },
        last_order_gap_delivery: {
          label: 'Seneste tidspunkt for bestilling til <strong>levering</strong> (minutter før lukketid)',
          option: '{{value}} min.',
        },
      },
    },
    delivery_info: {
      title: 'Leveringsinfo',
      fields: {
        average_order_delivery_time_min: {
          label: 'Leveringstid',
          placeholder: 'Tid i minutter',
        },
        average_order_delivery_time_max: {
          label: 'til',
          placeholder: 'Valgfri',
        },
      },
    },
    delivery_zones: {
      title: 'Leveringszoner',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    at_least_one_order_method_required:
      'Mindst 1 bestillingsmetode (planlagt eller ASAP) skal være slået til. Du kan ikke deaktivere begge.',
  },
};
